<template>
  <div class="view news">
    <div class="banner">
      <div class="banner-background">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1142" viewBox="0 0 1900 1142"><defs><clipPath id="nb-a"><rect width="1900" height="1142" fill="#fff"/></clipPath><linearGradient id="nb-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.08" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/></linearGradient><linearGradient id="nb-c" x1="0.871" y1="0.346" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.146" stop-color="#f77e0b"/><stop offset="0.533" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><filter id="nb-d" x="-996.427" y="-1678.665" width="3024.7" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="nb-f" x="375.422" y="185.645" width="193.792" height="172.539" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="nb-h" x="521.5" y="181.5" width="79" height="79" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="i"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="i"/><feComposite in="SourceGraphic"/></filter><filter id="nb-j" x="458.934" y="182.5" width="72" height="72" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="k"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="k"/><feComposite in="SourceGraphic"/></filter><filter id="nb-l" x="348.934" y="275.5" width="66" height="66" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="m"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter><filter id="nb-n" x="1604.653" y="329.564" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="o"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="o"/><feComposite in="SourceGraphic"/></filter><filter id="nb-p" x="1392.572" y="218.542" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="q"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="q"/><feComposite in="SourceGraphic"/></filter><filter id="nb-r" x="1382.652" y="401.5" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="s"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter><filter id="nb-t" x="877.5" y="687.5" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="u"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="u"/><feComposite in="SourceGraphic"/></filter><filter id="nb-v" x="815.5" y="648.5" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="w"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="w"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#nb-a)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#nb-b)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#nb-d)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#nb-c)"/></g></g><g transform="translate(68.434 -147)"><g transform="matrix(1, 0, 0, 1, -68.43, 147)" filter="url(#nb-f)"><path d="M68.217,20.585c24.151,19,39.31,1.247,62.548,39.415s-19.3,78.2-70.592,58.487S-11.6,74.365,7.566,38.2,44.066,1.585,68.217,20.585Z" transform="translate(403.43 194)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, -68.43, 147)" filter="url(#nb-h)"><circle cx="11" cy="11" r="11" transform="translate(550 198)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, -68.43, 147)" filter="url(#nb-j)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(487.43 199)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, -68.43, 147)" filter="url(#nb-l)"><circle cx="4.5" cy="4.5" r="4.5" transform="translate(377.43 292)" fill="#f77e0b"/></g></g><g transform="translate(0 -100)"><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#nb-n)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1641.75, 374.91)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#nb-p)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1427.71, 257.33)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#nb-r)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(1411.15 418)" fill="#f77e0b"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#nb-t)"><circle cx="8" cy="8" r="8" transform="translate(906 704)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#nb-v)"><circle cx="17" cy="17" r="17" transform="translate(844 665)" fill="#f77e0b"/></g></g></svg>
      </div>
    </div>
    <div class="wrapper">
      <div class="page-title">
        <h1>News</h1>
        <p v-if="page" v-html="page.headline.replace(/\n/g, '<br>')"></p>
      </div>
      <div class="posts">
        <div class="no-news" v-if="!posts.length">
          <p>Come back later for the <br>latest <b>CAST News...</b> <br>Stay Tuned!</p>
        </div>
        <NewsItem :post="post" class="post" v-for="post in posts" :key="post.id" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NewsItem from '../components/NewsItem'

export default {
  name: 'news',
  components: {
    NewsItem
  },
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    })
  },
  data() {
    return {
      posts: [],
      page: null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('news').onSnapshot(page => {
      this.page = page.data()
    })
    this.newsRef = this.db().collection('posts').orderBy('date', 'desc').onSnapshot(posts => {
      this.posts = posts.docs.map(doc => doc.data())
      if(this.posts.length) this.$store.commit('setPageLoading', false)
      else {
        this.preloadImages([
          require('@/assets/cast_news_nonews@2x.png')
        ])
        .then(() => {
          this.$store.commit('setPageLoading', false)
        })
        .catch(() => {
          this.$store.commit('setPageLoading', false)
        })
      }
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
    if(this.newsRef) this.newsRef()
  }
}
</script>

<style scoped>
.news {
  /* background: url(../assets/cast_news_banner.jpg) no-repeat top center/1920px auto; */
  padding-top: 226px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.page-title {
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title h1 {
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 400px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #F77E0B;
}

.posts {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 64px;
}

.posts .no-news {
  width: 1000px;
  height: 550px;
  background: url(../assets/cast_news_nonews@2x.png) no-repeat center/contain;
  margin: auto;
  color: #fff;
  padding-top: 210px;
  padding-right: 23%;
  text-align: right;
  font-size: 2.29em;
  line-height: 1.0625;
  margin-top: 80px;
}

.posts .post {
  width: 33.333333%;
  text-align: center;
  margin-top: 80px;
}

@media screen and (max-width: 1024px) {
  .page-title {
    color: #343434;
  }
  .page-title,
  .title-line {
    display: block;
    padding: 0;
    text-align: center;
    margin: 0;
  }
  .page-title h1 {
    color: #F77E0B;
    height: 48px;
  }
  .title-line h2 {
    font-size: 28px;
  }
  .page-title p,
  .title-line .subtitle {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before,
  .title-line h2:after {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #F77E0B;
  }
  .banner {
    height: auto;
  }
  .banner .wrapper {
    padding-bottom: 24px;
  }
  .banner .next-image svg {
    height: auto;
  }
  .banner .next-event {
    bottom: 0;
  }
  .events {
    margin-top: 72px;
  }
  .posts .post {
    margin-top: 16px;
  }
  .posts .no-news {
    height: auto;
    padding: 20% 23% 20% 0;
    margin-top: 48px;
  }
}

@media screen and (max-width: 920px) {
  .posts .post {
    width: 50%;
  }
}

@media screen and (max-width: 680px) {
  .news {
    padding-top: 172px;
  }
  .posts .no-news {
    font-size: 21px;
    padding-top: 107px;
    height: 300px;
    margin-top: 32px;
    padding-right: 24%;
  }
}

@media screen and (max-width: 600px) {
  .posts .post {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .posts .no-news {
    font-size: 18px;
    padding-top: 117px;
    padding-right: 16%;
  }
}
</style>

